var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2619 506 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #27d045;\n      }\n\n      .cls-2, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-width: 5px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36",
    id: "Group_36",
    transform: "translate(2300 73)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60,
    cy: 60,
    "data-name": "Ellipse 18",
    id: "Ellipse_18",
    r: 60,
    transform: "translate(319 433)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35",
    id: "Group_35",
    transform: "translate(254 386)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34",
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    "data-name": "Ellipse 19",
    id: "Ellipse_19",
    transform: "translate(94 75)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 31.5,
    cy: 31.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 31.5,
    cy: 31.5,
    r: 29
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1424,191l-4.6,16.3,16.9-4.7.9-5.2-11,3.5,2.9-10.5Z",
    "data-name": "Path 126",
    id: "Path_126",
    transform: "translate(-1325 -68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1266,90c0-.1,3.5-11.7,3.5-11.7l8.4,7.9Z",
    "data-name": "Path 127",
    id: "Path_127",
    transform: "translate(-1165 43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1439.3,160.6a9.4,9.4,0,0,0-3.9,6.1c-.5,3.9,1.9,7.9,1.9,7.9a50.876,50.876,0,0,0,8.6,9.8,30.181,30.181,0,0,0,9.6,5.1,11.378,11.378,0,0,0,6.4.6,9.167,9.167,0,0,0,4.8-3.2,9.851,9.851,0,0,0,.6-2.2,5.868,5.868,0,0,0,0-2c-.1-.7-7.3-4-8-3.8s-1.3,1.5-2.1,2.6-1.1,1.6-1.9,1.6-4.3-1.4-7.6-4.4a15.875,15.875,0,0,1-4.3-6s.6-.7,1.4-1.8a5.664,5.664,0,0,0,1.3-2.4c0-.5-2.8-7.6-3.5-7.9A11.852,11.852,0,0,0,1439.3,160.6Z",
    "data-name": "Path 128",
    id: "Path_128",
    transform: "translate(-1326.332 -68.467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.a16bfaa002670de0af4ed7a4d6b08264.svg";
export { ForwardRef as ReactComponent };